import React, { useState, useEffect, useMemo } from "react"


import { CardBody, Card } from "reactstrap"

import { axiosbaseurl } from "configure"
import Loader from "components/Common/Loader"
import CommonTable from "components/Common/CommonTable" 
import { useClientContext } from "../ClientContextBox"
import { stringSimilarity } from "string-similarity-js";

const DirectorsAndPSC = () => {

    const [table_data, settable_data] = useState([])
    const [loading, setLoading] = useState(false)
    const { houseNumber } = useClientContext()

    useEffect(() => {
        const handleAllClientTasks = async () => {
            try {
                setLoading(true)
                // const { data } = await axiosbaseurl.get(`/client/all/tasks/${client_id}`)
                const { data } = await axiosbaseurl.get(`/company/${houseNumber}`)

                if (data?.psc_data.length) {
                    settable_data(data?.psc_data?.map((item) => { 

                        const officersData = data?.officers?.map(off => ({ ...off, similar: stringSimilarity(off?.name, item.name,2, true) }))

                        const { occupation, officer_role, links } = officersData?.sort((a, b) => (b.similar - a.similar))[0];

                        // const { occupation, officer_role, links } = data?.officers?.find(off => off?.address?.premises == premises);

                        return ({
                            name: item.name, 
                            natures: item.natures_of_control,
                            occupation: occupation || 'N/A',
                            officer_role: officer_role || 'N/A',
                            psc_id: item?.links?.self?.split("/").slice(-1)[0] || "N/A",
                            officer_id: links?.officer?.appointments?.split("/")[2] || "N/A"
                        })
                    }))
                }
            } catch (error) {
                console.log(error)
            } finally {
                setLoading(false)
            }
        }
        if (houseNumber)
            handleAllClientTasks()
    }, [])

    // columns
    const columns = useMemo(
        () => [
            {
                Header: "ID",
                accessor: "id",
                filterable: true,
                disableFilters: true,
                Cell: cellProps => {
                    return <div> {cellProps.row.index + 1}</div>
                },
            },
            {
                Header: "Person",
                accessor: "name",
                disableFilters: true,
                filterable: true
            },
            {
                Header: "Role",
                accessor: "officer_role",
                disableFilters: true,
                filterable: true,
                className: "text-capitalize"
            },
            {
                Header: "Occupation",
                accessor: "occupation",
                disableFilters: true,
                filterable: true
            },
            {
                Header: "Ids",
                disableFilters: true,
                disableSort: true,
                Cell: cellProps => {
                    const { psc_id, officer_id } = cellProps.row.original

                    return (
                        <>
                            <div style={{ fontSize: "11px" }} >
                                <div> <b>PSC ID :</b> <br /> {psc_id}</div>
                                <div className="mt-1"> <b>Officer ID :</b> <br /> {officer_id}</div>
                            </div>
                        </>
                    )
                },
            },
            {
                Header: "Nature of Control",
                disableFilters: true,
                disableSort: true,
                accessor: "view",
                Cell: cellProps => {
                    const { natures } =
                        cellProps.row.original
                    return (
                        <>
                            <div className="d-flex flex-column gap-1" >
                                {
                                    natures?.map(item => (<div key={item}
                                        className="px-1 py-1 badge text-dark border text-capitalize border-primary d-block">{item.replaceAll("-", " ")}</div>))
                                }
                            </div>
                        </>
                    )
                },
            },
        ],
        []
    )

    return (
        <>
            {loading && <Loader />}

            <Card className="px-0 mx-0" style={{ minHeight: "70vh" }}>
                <CardBody >
                    <CommonTable
                        columns={columns}
                        data={table_data}
                        heading={"Directors & PSC’s"}
                    >
                    </CommonTable>
                </CardBody>
            </Card>
        </>
    )
}

export default DirectorsAndPSC
